// This import loads the firebase namespace along with all its type information.
import ContentCarrier from './content-carrier-model'

export async function load_contentCarriers(): Promise<ContentCarrier[]> {
  throw 'Not implemented'
}

export async function delete_contentCarrier(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_contentCarrier(): Promise<ContentCarrier> {
  throw 'Not implemented'
}
